export default {"src":"/_next/static/media/gift.4e172f07.svg","height":235,"width":234,"blurWidth":0,"blurHeight":0};